import 'babel-polyfill';
import './vendors/modernizr-custom';
import $ from 'jquery';
import debounce from 'lodash/debounce';
import smoothscroll from 'smoothscroll-polyfill';
import Slick from 'slick-carousel';
import tippy from 'tippy.js';
import Stickyfill from '../../node_modules/stickyfilljs/dist/stickyfill';
import mobile from 'is-mobile';
import './components/jquery-fancy-hover';
import CaseList from './components/case-list';
import TopBar from './components/top-bar';
import Layer from './components/layer';
// import CookieBar from './components/cookie-bar';
import MainSlider from './components/main-slider';
import Marquee from './components/marquee';
import FilteredList from './components/filtered-list';
import CaseHeader from './components/case-header';
import HeaderHightlight from './components/header-highlight';
import Form from './components/form';
import Webform from './components/webform';
import BottomBar from './components/bottom-bar';
import VideoPlayer from './components/video-player';
import Orphans from './components/orphans';
import Accordion from './components/accordion';
import BuScrollAnimation from './components/bu-scroll-animation';
import WebFont from 'webfontloader';
import NewsList from './components/news-list';
import {triggerEvent} from './base/utils';

class App {
    constructor() {
        smoothscroll.polyfill();

        this.isMobile = mobile({tablet: true, featureDetect: true});
        this.init();
    }

    init() {
        let $newsletterBar = $('#newsletter-bar'),
            $contactBar = $('#contact-bar'),
            $contactBarMobile = $('#contact-bar-mobile'),
            $contactBubble = $('#contact-bubble'),
            $jobOfferBar = $('#job-offer-bar'),
            $mainSlider = $('.main-slider'),
            $caseHeader = $('.header-case'),
            $headerHighlight = $('.header-highlight');
        let config = {item: '.accordion-item', trigger: '.accordion-trigger', body: '.accordion-body', bodyInner: '.accordion-body-inner'}
        this.accordion= document.querySelectorAll('.accordion')
        this.$body = $('body');
        document.addEventListener('accordionchange', this.accordionchange.bind(this), false);
        this.initModule('.accordion', 'accordion');
        document.addEventListener('accordionchange', this.accordionchange.bind(this), false);
        this.initFancyHover();

        new BuScrollAnimation();

        $(window).on('resize', debounce(this.calculateFontSize.bind(this), 30))
            .resize();



        new TopBar();


        new Marquee(60);

        new Layer();

        // new CookieBar();

        if ($newsletterBar.length) {
            new BottomBar({
                $bar: $newsletterBar,
                $hideTrigger: $('.newsletter-teaser'),
                triggerPositionFraction: 0.5
            });
        }

        if ($contactBar.length) {
            new BottomBar({
                $bar: $contactBar,
                $hideTrigger: $('.footer'),
                triggerPositionFraction: 0.5
            });
        }

        if ($contactBarMobile.length) {
            new BottomBar({
                $bar: $contactBarMobile,
                mobile: true,
                $hideTrigger: $('.footer'),
                $showTrigger: $('.header')
            });
        }

        if ($contactBubble.length) {
            new BottomBar({
                $bar: $contactBubble,
                $hideTrigger: $('.footer'),
                $showTriggerEnd: $('.header')
            });
        }

        if ($jobOfferBar.length) {
            new BottomBar({
                $bar: $jobOfferBar,
                triggerPositionFraction: 0.3
            });
        }

        if ($mainSlider.length) {
            new MainSlider($mainSlider);
        }

        if ($caseHeader.length) {
            new CaseHeader();
        }

        if ($headerHighlight.length && !this.isMobile) {
            new HeaderHightlight();
        }

        $('.filtered-list').each((id, el) => {
            new FilteredList(el);
        });

        $('.js-case-filtered-list').each((id, el) => {
            new CaseList(el);
        });

        $('.ipresso-form').each((id, el) => {
            new Form(el);
        });

        $('.webform').each((id, el) => {
            new Webform(el);
        });

        $('.video-player').each((id, el) => {
            new VideoPlayer(el);
        });

        $('.article-body-text').each((id, el) => {
            new Orphans(el);
        });

        $('.js-news-list').each((id, el) => {
            new NewsList(el);
        });

        this.initSlider();
        this.initTooltip();
        this.initMoreLinks();
        this.setHeaderColor();

        Stickyfill.add($('.filter-categories'));

        this.$body.trigger('font-size-change');

        if (window.location.hash) {
            $(`[data-id="${window.location.hash.substr(1)}"]`).trigger('open', {source: 'hash'});
        }
    }
    accordionchange(e) {
        triggerEvent(e.target, 'resize');
    }
    tabchange(e) {
        [...e.target.querySelectorAll('.accordion')].forEach(el => triggerEvent(el, 'resize', null, false));
    }
    initModule(selector, moduleName, params = []) {
        let $element = document.querySelectorAll(selector);

        if ($element.length) {
            import(/* webpackChunkName: "[request]" */ `./components/${moduleName}.js`)
                .then(({default: Module}) => {
                    [...$element].forEach($el => {
                        new Module($el, ...params);
                    });
                })
                .catch(error => 'An error occurred while loading the component');
        }
    }
    calculateFontSize() {
        let $html = $('html'),
            oldSizeReal = $html.css('font-size'),
            oldSizeRounded = Math.floor(parseFloat(oldSizeReal) * 100) / 100,
            winWidth = $(window).outerWidth(),
            ratio = winWidth / 1920,
        // fontSize = Math.max(Math.floor(1000 * ratio) / 100, 1);
            fontSize = Math.max((winWidth < 768) ? Math.round(10 * ratio) : Math.floor(1000 * ratio) / 100, 1); // na iphonie przegladarka zaokragle fonty do pelnych pikseli, wiec triggeruje sie event nawet mimo braku zmiany wielkosci => zaokraglamy do pelnych pikseli

        $html.css('font-size', `${fontSize}px`);

        if (oldSizeRounded !== fontSize)
            this.$body.trigger('font-size-change');
    }

    setHeaderColor() {
        let $header = $('.header');

        this.$body.toggleClass('dark-header', $header.hasClass('dark'));
        this.$body.toggleClass('sm-dark-header', $header.hasClass('sm-dark'));
    }

    initFancyHover() {
        const fancyLinks = {
            def: [
                '.main-nav a',
                // '.secondary-nav a',
                '.blog-promo a',
                '.filter-list a',
                '.filter-list .item',
                '.news-list h3 a',
                '.footer-links a',
                '.social-links a',
                '.case-teaser .title'
            ],
            alternate: [
                'p a',
                '.article-body-text a',
                '.category a',
                '.side-links a',
                '.article-meta a',
                '.case-meta a',
                '.toggle-more',
                '.filter-label',
                '.link',
                '.footer-contact .contact-form-trigger',
                '.footer-contact p a',
                '.footer-group-item a',
                '.author-info .contact-form-trigger',
                '.contact-text dd a',
                '.contact__address dd a'
            ],
            backgroundless: [
                '.lang-menu a',
                '.inline-nav a'
            ],
            backgroundlessAlternate: [
                '.background + .header-content a',
                '.background + .header-content .contact-form-trigger',
                'a.slider-category',
                '.top-bar-title',
                '.inline-nav .active a',
                '.bu-description-name-url'
            ]
        };
        let loaded = 0;

        WebFont.load({
            custom: {
                families: ['Maitree', 'Gilroy']
            },
            active: () => {
                loaded++;

                // timeout poprawiajacy podkreslenie na niektorych iphonach - mimo zaladowania fonta wyliczane sa bledne wysokosci
                setTimeout(() => {
                    this.triggerFancyHover(fancyLinks, loaded);
                }, 300);
            }
        });

        this.$body.one('font-size-change', () => {
            loaded++;
            this.triggerFancyHover(fancyLinks, loaded);
        });
    }

    triggerFancyHover(fancyLinks, loaded) {
        if (loaded >= 2) {
            if (!this.isMobile) {
                $(fancyLinks.def.join(', ')).fancyHover();
                $(fancyLinks.backgroundless.join(', ')).fancyHover({
                    background: false
                });
            }
            $(fancyLinks.alternate.join(', ')).fancyHover({
                hover: 'alternate'
            });
            $(fancyLinks.backgroundlessAlternate.join(', ')).fancyHover({
                background: false,
                hover: 'alternate'
            });
            document.body.classList.remove('preload');
        }
    }

    initSlider() {
        $('.slick')
            .on('init', (e, slick) => {
                let $slider = slick.$slider.closest('.slider-wrapper'),
                    $category = $slider.find('.slider-category');

                $category
                    .addClass('slider-category-white')
                    .clone()
                    .removeClass('slider-category-white')
                    .addClass('slider-category-black')
                    .appendTo($category.parent());

                this.checkSliderTitle($slider.find('.slick-active')[0]);
                this.preloadClonedImages($slider);
            })
            .on('beforeChange', (e, slick, prev, next) => {
                this.checkSliderTitle(slick.$slides[next]);
            })
            .slick({
                nextArrow: '<button class="slider-arrow slider-arrow-next ico ico-arrow-right"></button>',
                prevArrow: '<button class="slider-arrow slider-arrow-prev ico ico-arrow-left"></button>',
                dotsClass: 'slider-dots',
                dots: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true
                        }
                    }
                ]
            });
    }

    preloadClonedImages($slider) {
        let $clonedImages = $slider.find('.slick-cloned .image.lazyload');

        $clonedImages.find('source').each((id, el) => {
            let $el = $(el);

            $el.attr('srcset', $el.data('srcset'));
        });

        $clonedImages.find('img').each((id, el) => {
            let $el = $(el);

            $el.attr('src', $el.data('src'));
        });

        $clonedImages.removeClass('lazyload');
    }

    checkSliderTitle(slide) {
        let black = $(slide).find('.slide-black').length > 0,
            $slider = $(slide).closest('.slider-wrapper');

        $slider.toggleClass('slider-black-text', black);
    }

    initTooltip() {
        let tippyOptions = {
            arrow: true,
            distance: 4,
            delay: [100, 0],
            duration: [350, 100],
            hideOnClick: false,
            html: '#tooltip',
            interactive: true,
            maxWidth: '80rem',
            // performance: true,
            trigger: 'manual',
            onShown(instance) {
                $(instance.popper).find('.tooltip-text')
                    .html($(instance.reference).closest('label').find('.more').html());
            }
        };

        $(`<div id="tooltip" style="display: none;">
                <button class="tooltip-close"><span></span></button>
                <div class="tooltip-text"></div>
            </div>`)
            .insertAfter('.page-wrap');

        tippy('.tooltip', tippyOptions);

        this.$body
            .on('click', '.tooltip', e => {
                e.preventDefault();

                $('.tippy-popper').each((id, el) => {
                    el._tippy.hide();
                });

                e.target._tippy.show();
            })
            .on('click', '.tooltip-close', e => {
                e.preventDefault();

                let $popper = $(e.target).closest('.tippy-popper');

                $popper[0]._tippy.hide();
            })
            .on('layer-closing', (e, layer) => {
                $(layer).find('[data-tippy]').each((id, el) => {
                    if (el._tippy && el._tippy.state.visible) {
                        el._tippy.hide();
                    }
                });
            })
            .on('form-reload', e => {
                $(e.target).find('.tooltip').each((id, el) => {
                    tippy(el, tippyOptions);
                });
            });
    }

    initMoreLinks() {
        this.$body.on('click', '.toggle-more', e => {
            e.preventDefault();

            $(e.currentTarget).closest('label').toggleClass('more-visible');
        });
    }
}

document.addEventListener('DOMContentLoaded', () => new App());



// WEBPACK FOOTER //
// ./sources/js/main.js